import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ArrowDownIcon } from '../icons';
import React, { useCallback, useRef, useState } from 'react';
const ConfigImport = ({ json, jsonError, notes, onJson }) => {
    const [pasting, setPasting] = useState(false);
    const [fileError, setFileError] = useState();
    const [dragging, setDragging] = useState(false);
    const fileRef = useRef(null);
    const onFile = useCallback((file) => {
        if (!file)
            return;
        setFileError(undefined);
        file.text()
            .then(onJson)
            .catch(() => setFileError('Could not read that file.'));
    }, [onJson]);
    return (_jsxs("div", { className: 'cfg__import', children: [pasting ? (_jsx("textarea", { className: 'cfg__box cfg__json', value: json, spellCheck: false, autoComplete: 'off', autoFocus: true, "aria-label": 'Server config JSON', onChange: (e) => onJson(e.target.value) })) : (_jsxs("div", { className: dragging ? 'cfg__box cfg__drop cfg__drop--over' : 'cfg__box cfg__drop', onDragOver: (e) => {
                    e.preventDefault();
                    setDragging(true);
                }, onDragLeave: () => setDragging(false), onDrop: (e) => {
                    e.preventDefault();
                    setDragging(false);
                    onFile(e.dataTransfer.files[0]);
                }, children: [_jsx(ArrowDownIcon, { w: 17, h: 17, sw: 2 }), _jsxs("div", { className: 'cfg__drop-title', children: [_jsx("span", { className: 'cfg__drop-drag', children: "Drop your config file here" }), _jsx("span", { className: 'cfg__drop-tap', children: "Add your config file" })] }), _jsx("button", { className: 'cfg__choose', onClick: () => fileRef.current?.click(), children: "Choose file\u2026" })] })), _jsx("button", { className: 'cfg__swap', onClick: () => setPasting((previous) => !previous), children: pasting ? 'Use a file instead' : 'Paste JSON instead' }), _jsx("input", { ref: fileRef, className: 'cfg__file', type: 'file', accept: '.json,application/json', onChange: (e) => {
                    onFile(e.target.files?.[0]);
                    e.target.value = '';
                } }), (fileError ?? jsonError) && _jsx("div", { className: 'cfg__err', children: fileError ?? jsonError }), notes.map((note) => (_jsx("div", { className: 'cfg__note', children: note }, note)))] }));
};
export default React.memo(ConfigImport);
